// extracted by mini-css-extract-plugin
export default {"projectMemberHeaderNavContainer":"ProjectMemberHeaderNav_projectMemberHeaderNavContainer__kw0U5"};